import { OrganizationKeyName } from "../../../model/Organization";

export const GET_SHOP_LIST_FAIL = "SHOP:GET_SHOP_LIST_FAIL";

export const getShopListFailAction = (organization: OrganizationKeyName) => ({
  type: GET_SHOP_LIST_FAIL as typeof GET_SHOP_LIST_FAIL,
  organization,
});

export type GetShopListFailAction = ReturnType<typeof getShopListFailAction>;
